import { CheckboxField as ShellCheckboxField } from '@e3dc-react/shell/Elements/InputFields'
import React, { forwardRef, useCallback, useMemo } from 'react'
import { useField, useFormikContext } from 'formik'
import { CheckboxFieldProps } from '@e3dc-react/shell/Elements/InputFields/checkbox/CheckboxField'

interface LocalProps extends CheckboxFieldProps<boolean> {
  mask?: string | undefined
  checked?: boolean
  onChange?: (value: boolean) => void
}

const Checkbox = forwardRef<typeof ShellCheckboxField, LocalProps>(({ checked = false, onChange, ...props }, ref) => {
  const { setFieldValue } = useFormikContext()
  const [field, meta] = useField(props.name as string)

  const hasError = useMemo<boolean>(
    () => {
      if (props.disabled) return false
      return Boolean(meta.error && (meta.initialValue !== meta.value || meta.touched))
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [props.name, meta]
  )

  const handleCheckEvent = useCallback(
    (event: boolean) => {
      if (props?.name) {
        setFieldValue(props.name, event)
      } else {
        console.warn('Invalid fieldName', props.name)
      }

      if (onChange) {
        onChange(event as boolean)
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [setFieldValue, onChange]
  )

  return (
    <ShellCheckboxField
      {...props}
      value={field.value}
      onChange={handleCheckEvent}
      checked={checked || field.value}
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      ref={ref}
      error={hasError}
      helperText={hasError ? meta.error : undefined}
    />
  )
})

Checkbox.displayName = 'Checkbox'

export default Checkbox
